<section class="custom-footer">
    <div class="landing-container">
        <div class="grid">
            <div class="col-12 md:col-6 lg:col-4">
            <app-join-us></app-join-us>
            </div>
            <div class="col-12 md:col-6 lg:col-8">
                <app-footer-form></app-footer-form>
            
            </div>
        </div>
        </div>
</section>
